import { api, ep } from "aldoo-ra/API"
import axios from "axios"

// Construct the API endpoints
const userAPI = api("user")
const deviceAPI = api("user-device")
const otpAPI = api("otp")

export const IsDeviceLogged = async (auth) => {
  return await deviceAPI({ login_state: auth })
}

// Validate a one-time login token (from the mobile app). When `deviceID` is
// passed the backend logs this device in and returns an auth_token, so the web
// can establish a full session. Response: { valid, auth_token, user }.
export const ValidateOTP = async (otp, deviceID) => {
  return await otpAPI({ validate: { otp, deviceID } })
}

export const GetUserProfile = async (profile) => {
  return await userAPI({ profile })
}

export const ChangeUsername = async (name) => {
  return await userAPI({ profile: { update: { name } } })
}

export const UploadUserAvatar = async (file, mimeType) => {
  const { getValue } = await import("aldoo-ra/Value")
  const credentials = getValue("user-credentials", "user-credentials")
  const ext = mimeType?.split("/")?.[1] || "jpg"
  const formData = new FormData()
  formData.append("avatar_upload", file, `avatar.${ext}`)
  const headers = {}
  if (credentials?.auth_token) headers["Authorization"] = credentials.auth_token
  const response = await axios.post(ep("user"), formData, { headers })
  return response.data
}

export const UserPreferences = async (selector) => {
  return await userAPI({ preferences: { data: selector } })
}

// Persist marketing attribution (utm_* + click ids + referrer/landing) for
// the signed-in user. Server applies first-touch-wins, so re-sending is safe.
export const SetUserAttribution = async (data) => {
  return await userAPI({ attribution: { data } })
}

export const Login = async (credentials, userFields) => {
  credentials = userFields ? { ...credentials, ...userFields } : credentials
  return await userAPI({ login: credentials })
}

/**
 * Logout the user from the system
 * @returns
 */
export const Logout = async () => {
  return await userAPI({ logout: true })
}

export const VerifyCredentials = async (credentials) => {
  return await userAPI({ verify: credentials })
}

export const CreateDevice = async ({ fid }) => {
  // Native app WebViews (e.g. the AldooSnap mac app) inject
  // window.AldooNativeApp = { platform, model } so the device registers
  // with the real platform/OS instead of the generic "Web" + user agent.
  const native = typeof window !== "undefined" ? window.AldooNativeApp : null
  const payload = {
    create: {
      platform: native?.platform || "Web",
      model: native?.model || navigator.userAgent,
      // Native apps pass the user-visible computer name so the device is
      // recognizable in account/license device lists.
      ...(native?.name && { name: native.name }),
      fid,
    },
  }
  return await deviceAPI(payload)
}

export const RequestInternalID = async (auth) => {
  return await userAPI({ internal_id: auth })
}

export const CreateUser = async (auth) => {
  return await userAPI({ create: auth })
}

// Export the API methods as default
export default {
  IsDeviceLogged,
  GetUserProfile,
  UserPreferences,
  Login,
  Logout,
  VerifyCredentials,
  CreateDevice,
  RequestInternalID,
  CreateUser,
  ChangeUsername,
  SetUserAttribution,
}
